import * as actions from './actionsSagas';
import * as constants from './constants';
import reducer from './reducer';
import * as selectors from './selectors';
import sagas from './sagas';

export default { actions, constants, selectors, reducer, sagas };
